import React, { useState,useContext, useEffect } from "react";
import { makeStyles,useTheme } from "@material-ui/core/styles";
import {
	AppBar,
	Toolbar,
	Typography,
	IconButton,
	Snackbar,
	SnackbarContent,
	LinearProgress,
	Grid
} from "@material-ui/core";

import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";

import { PageContext } from "../../contexts/PageContext";
import ConfirmDialog from "../general/ConfirmDialog";
import InfoDialog from "../general/InfoDialog";


const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		zIndex: 20,
		color: "#fff",
		paddingBottom:7
		// [theme.breakpoints.up("lg")]: {
		// 	width: `calc(100% - ${drawerWidth}px)`,
    //   marginLeft: drawerWidth,
		// }
	},
	logo: {
		display: "flex",
		alignItems:"flex-end",
		textDecoration: "none",
		marginTop: theme.spacing(1),
		"& img": {
			width: 80,
			height: "auto",
		},
		"& span": {
			fontSize: 14,
			fontWeight: 600,
			letterSpacing:2,
			color: "#ddd",
			marginLeft: 10,
			marginBottom:4
		}
	},
	customername: {
		marginBottom: 1,
	},
	infoMessageBarContent: {
		backgroundColor: theme.palette.secondary.dark,
		color: "#fff",
	},
	errorMessageBarContent: {
		backgroundColor: theme.palette.error.dark,
		whiteSpace: "pre-line"
	},
	snackbarIcon: {
		fontSize: 20,
		marginRight: theme.spacing(1),
		verticalAlign: -4,
	},
	loadingBar: {
		position: "absolute",
		left: 0,
		right: 0,
		top: 0,
	},
}));

export default function PortalHeader(props) {
	const theme = useTheme();
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const pageContext = useContext(PageContext);
	function handleMenu(event) {
		setAnchorEl(event.currentTarget);
	}

	function handleClose() {
		setAnchorEl(null);
	}

	return (
		<React.Fragment>
			<AppBar
				position="fixed"
				className={classes.root}
				color="primary"
				elevation={0}
			>
				<Toolbar>
					<Grid container spacing={2} alignItems="flex-end" justifyContent="space-between">
						<Grid
							item
							className={classes.logo}
						>
							<img src="/logo.png" /><span>KUNDENPORTAL</span>
						</Grid>
						<Grid
							item
						>
							<Typography
								className={classes.customername}
							>{props.customername}</Typography>
						</Grid>
					</Grid>					
				</Toolbar>
				{pageContext.isLoading && (
					<LinearProgress className={classes.loadingBar} />
				)}
			</AppBar>
			{pageContext.errorMessage && (
				<Snackbar
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "left",
					}}
					open={
						pageContext.errorMessage !== null && pageContext.errorMessage !== ""
					}
					onClose={() => {
						pageContext.setErrorMessage("");
					}}
				>
					<SnackbarContent
						className={classes.errorMessageBarContent}
						aria-describedby="client-snackbar"
						message={
							<span id="client-snackbar">
								<ErrorIcon className={classes.snackbarIcon} />
								{pageContext.errorMessage}
							</span>
						}
						action={
							<IconButton
								aria-label="close"
								color="inherit"
								className={classes.close}
								onClick={() => {
									pageContext.setErrorMessage("");
								}}
							>
								<CloseIcon />
							</IconButton>
						}
					/>
				</Snackbar>
			)}
			{pageContext.infoMessage && (
				<Snackbar
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "left",
					}}
					open={
						pageContext.infoMessage !== null && pageContext.infoMessage !== ""
					}
					autoHideDuration={6000}
					onClose={() => {
						pageContext.setInfoMessage("");
					}}
				>
					<SnackbarContent
						className={classes.infoMessageBarContent}
						aria-describedby="client-snackbar"
						message={
							<span id="client-snackbar">
								<InfoIcon className={classes.snackbarIcon} />
								{pageContext.infoMessage}
							</span>
						}
					/>
				</Snackbar>
			)}
			<ConfirmDialog {...pageContext.confirmDialog} />
			<InfoDialog {...pageContext.infoDialog} />
		</React.Fragment>
	);
}
